export default __webpack_public_path__ + "static/media/10458 - EKCS.b5610d9e.jpeg";